import React from 'react';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {Row, Col, Steps, Spin, message, Tag} from 'antd';
import {openNotice} from 'Utils';
import {getOrderLineTrack, getOrderLineTrackList} from '../../service/order';
import {getGouXiaoUnitList} from '../../service/traceOrder';
import moment from 'moment';
import './order.css';

const Step = Steps.Step;

const nodeType = {
    booked: '已登记',
    canceled: '已取消',
    scheduled: '排产中',
    inventory: '已入库',
    locked: '已锁库',
    picked: '已拣货',
    shipped: '已发运',
    check: '已排产',
    begin: '已开工',
    complete: '已完工',
    transfer: '发往分物流'
};

const dayMap = {
    '0': '周日',
    '1': '周一',
    '2': '周二',
    '3': '周三',
    '4': '周四',
    '5': '周五',
    '6': '周六',
};

const TRACK_STATUS_ALL = 'ALL';

const TRACK_STATUS_LIST = [
    {label: '全部', value: TRACK_STATUS_ALL},    
    {label: '接单处理', value: '接单处理'},
    {label: '车间生产', value: '车间生产'},
    {label: '锁库待发', value: '锁库待发'},
];

const TRACK_STATUS_COLOR = {
    '车间生产': 'blue',
    '接单处理': 'orange',
    '锁库待发': 'green',
};

class OrderTrackQuery extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['未发跟踪'],
            rows: [],
            total: 0,
            loading: false,
            buyCompanyOptions: [],
            orderLineTracks: {},
            expandedRowKeys: [],
            gpsTracks: [],
            trackLoadingId: null,
            formKey: 0,
            statusSummary: {
                '车间生产': 0,
                '接单处理': 0,
                '锁库待发': 0,
            },
            searchObj: {
                getProCode: '',
                orderCode: '',
                buyCompanyId: '',
                productCode: '',
                productName: '',
                qhFlag: '',
                status: TRACK_STATUS_ALL,
                startCreatedDate: moment().add(-1, 'y').format('YYYY-MM-DD'),
                endCreatedDate: moment().format('YYYY-MM-DD'),
                p: 1,
                s: 10,
            },
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
    }

    componentDidMount() {
        const buttonLimits = JSON.parse(window.localStorage.getItem('button_limits_end') || '{}');
        if (!buttonLimits.orderTrackQuery) {
            openNotice('warning', '无访问权限');
            hashHistory.push('/home');
            return;
        }
        const channelCode = window.sessionStorage.getItem('cur_channelId');
        getGouXiaoUnitList({channelCode: channelCode, s: 999}).then(res => {
            if (res.status) {
                const arr = [{text: '全部', value: ''}];
                (res.data || []).forEach(x => {
                    arr.push({text: x.name, value: x.id});
                });
                this.setState({buyCompanyOptions: arr});
            }
        });
        this.fetchData();
    }

    setFilterParam(name, value) {
        if (name === 'orderTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    startCreatedDate: value.from,
                    endCreatedDate: value.end,
                },
            });
            return;
        }
        if (name === 'status' && !value) {
            value = TRACK_STATUS_ALL;
        }
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                [name]: typeof value === 'string' ? value.trim() : value,
            },
        });
    }

    advanceReset() {
        this.setState({
            searchObj: {
                getProCode: '',
                orderCode: '',
                buyCompanyId: '',
                productCode: '',
                productName: '',
                qhFlag: '',
                status: TRACK_STATUS_ALL,
                startCreatedDate: moment().add(-1, 'y').format('YYYY-MM-DD'),
                endCreatedDate: moment().format('YYYY-MM-DD'),
                p: 1,
                s: 10,
            },
            formKey: this.state.formKey + 1,
            rows: [],
            total: 0,
            statusSummary: {
                '车间生产': 0,
                '接单处理': 0,
                '锁库待发': 0,
            },
            orderLineTracks: {},
            expandedRowKeys: [],
            gpsTracks: [],
            trackLoadingId: null,
        });
    }

    advanceSubmit() {
        this.setState({
            searchObj: {...this.state.searchObj, p: 1},
            loading: true,
            orderLineTracks: {},
            expandedRowKeys: [],
            gpsTracks: [],
            trackLoadingId: null,
        }, () => this.fetchData());
    }

    pageChange(page, pageSize) {
        this.setState({
            searchObj: {...this.state.searchObj, p: page, s: pageSize},
            loading: true,
            orderLineTracks: {},
            expandedRowKeys: [],
            gpsTracks: [],
            trackLoadingId: null,
        }, () => this.fetchData());
    }

    buildQueryParam() {
        const {searchObj} = this.state;
        const param = {
            getProCode: searchObj.getProCode,
            orderCode: searchObj.orderCode,
            buyCompanyId: searchObj.buyCompanyId || undefined,
            productCode: searchObj.productCode,
            productName: searchObj.productName,
            qhFlag: searchObj.qhFlag || undefined,
            startCreatedDate: searchObj.startCreatedDate,
            endCreatedDate: searchObj.endCreatedDate,
            p: searchObj.p,
            s: searchObj.s,
        };
        if (searchObj.status && searchObj.status !== TRACK_STATUS_ALL) {
            param.status = searchObj.status;
        }
        return param;
    }

    fetchData() {
        this.setState({loading: true});
        getOrderLineTrackList(this.buildQueryParam()).then(result => {
            if (result && result.status && result.code == 200) {
                const dataMap = result.dataMap || {};
                const statusSummary = dataMap.statusSummary || {};
                this.setState({
                    rows: result.data || [],
                    total: result.total || 0,
                    statusSummary: {
                        '车间生产': statusSummary['车间生产'] || 0,
                        '接单处理': statusSummary['接单处理'] || 0,
                        '锁库待发': statusSummary['锁库待发'] || 0,
                    },
                    loading: false,
                });
            } else {
                openNotice('error', result.message || '查询失败');
                this.setState({
                    rows: [],
                    total: 0,
                    statusSummary: {
                        '车间生产': 0,
                        '接单处理': 0,
                        '锁库待发': 0,
                    },
                    loading: false,
                });
            }
        }).catch(() => {
            openNotice('error', '查询失败');
            this.setState({loading: false});
        });
    }

    getStatusTotalCount() {
        const {statusSummary} = this.state;
        return (statusSummary['车间生产'] || 0)
            + (statusSummary['接单处理'] || 0)
            + (statusSummary['锁库待发'] || 0);
    }

    getStatusCount(status) {
        if (!status || status === TRACK_STATUS_ALL) {
            return this.getStatusTotalCount();
        }
        return this.state.statusSummary[status] || 0;
    }

    filterByStatus = (status) => {
        const nextStatus = status || TRACK_STATUS_ALL;
        if (this.state.searchObj.status === nextStatus) {
            return;
        }
        this.setState({
            searchObj: {...this.state.searchObj, status: nextStatus, p: 1},
            formKey: this.state.formKey + 1,
            loading: true,
            orderLineTracks: {},
            expandedRowKeys: [],
            gpsTracks: [],
            trackLoadingId: null,
        }, () => this.fetchData());
    };

    formatDate(text) {
        if (!text) {
            return '';
        }
        if (typeof text === 'string') {
            return text.length > 10 ? text.substring(0, 10) : text;
        }
        return moment(text).format('YYYY-MM-DD');
    }

    getRowKey(record) {
        return record.lineId;
    }

    openInfo = (record) => {
        const rowKey = this.getRowKey(record);
        let {orderLineTracks, expandedRowKeys, trackLoadingId} = this.state;
        if (trackLoadingId === rowKey) {
            return;
        }
        if (expandedRowKeys.includes(rowKey)) {
            this.setState({
                expandedRowKeys: expandedRowKeys.filter(x => x !== rowKey),
                trackLoadingId: null,
            });
            return;
        }
        if (orderLineTracks[rowKey]) {
            this.setState({expandedRowKeys: [rowKey]});
            return;
        }
        if (!record.lineId) {
            message.error('缺少参数lineId，无法获取跟踪记录！！');
            return;
        }
        this.setState({trackLoadingId: rowKey, expandedRowKeys: []});
        getOrderLineTrack(record.lineId).then(res => {
            if (res.status) {
                const data = res.data;
                data.track = (data.track || []).filter(x => !!x.TRANSACTION_DATE && /\d{10}/.test(x.TRANSACTION_DATE)).map(x => {
                    const d = new Date(parseInt(x.TRANSACTION_DATE, 10) * 1000);
                    return {
                        date: d.format('yyyy-MM-dd'),
                        day: dayMap[d.getDay()],
                        time: d.format('hh:mm:ss'),
                        type: nodeType[x.TYPE],
                        msg: x.MESSAGE,
                        timestamp: d.getTime(),
                    };
                });
                const nextGpsTracks = [];
                (data.gps || []).forEach(item => {
                    nextGpsTracks.push([item.longitude, item.latitude]);
                });
                this.setState({
                    orderLineTracks: {
                        ...this.state.orderLineTracks,
                        [rowKey]: data,
                    },
                    gpsTracks: nextGpsTracks,
                    expandedRowKeys: [rowKey],
                    trackLoadingId: null,
                }, () => this.renderMap(nextGpsTracks));
            } else {
                openNotice('error', res.message || '获取跟踪记录失败');
                this.setState({trackLoadingId: null});
            }
        }).catch(() => {
            openNotice('error', '获取跟踪记录失败');
            this.setState({trackLoadingId: null});
        });
    };

    renderMap(trailCoordinates) {
        if (!trailCoordinates || trailCoordinates.length === 0) {
            return;
        }
        const scriptId = 'amap-order-track-script';
        const render = () => {
            const container = document.getElementById('order-track-map-container');
            if (!container || !window.AMap) {
                return;
            }
            const map = new window.AMap.Map('order-track-map-container', {
                zoom: 13,
                center: [116.397428, 39.90923],
            });
            const polyline = new window.AMap.Polyline({
                path: trailCoordinates,
                strokeWeight: 5,
                strokeColor: '#800080',
                lineJoin: 'round',
            });
            map.add(polyline);
            trailCoordinates.forEach((coord, index) => {
                new window.AMap.Marker({
                    position: coord,
                    content: `<div style="background-color: ${
                        index === 0 ? '#00FF00' : '#FF0000'
                    }; width: 10px; height: 10px; border-radius: 50%; display: ${
                        index === 0 || index === trailCoordinates.length - 1 ? 'block' : 'none'
                    };"></div>`,
                }).addTo(map);
            });
            map.setFitView();
        };
        if (window.AMap) {
            render();
            return;
        }
        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script');
            script.id = scriptId;
            script.src = 'https://webapi.amap.com/maps?v=2.0&key=348a4830947424baf8327c22d1386067';
            script.async = true;
            script.onload = render;
            document.head.appendChild(script);
        } else {
            render();
        }
    }

    renderExpandedRow = (record) => {
        const {orderLineTracks, gpsTracks} = this.state;
        const rowKey = this.getRowKey(record);
        if (!orderLineTracks[rowKey]) {
            return null;
        }
        const info = orderLineTracks[rowKey] || {};
        const quantity = info.quantity || {};
        return (
            <div>
                <p className="track-bref">订单跟踪详情</p>
                <Row gutter={16}>
                    <Col span={1}>
                    </Col>
                    <Col span={20} style={{padding: '0 15px', borderLeft: 'solid 1px #ddd'}}>
                        <Steps className="dms-steps">
                            <Step
                                status={quantity.SHIPPED_QUANTITY > 0 || quantity.LOCKED_QUANTITY > 0 || quantity.SCHEDULED_QUANTITY > 0 || quantity.PLAN_QUANTITY > 0 || quantity.ORDERED_QUANTITY > 0 ? 'finish' : 'wait'}
                                title="订单登记"
                                description={`数量 ${quantity.ORDERED_QUANTITY}`}
                                icon={<span className="tengen icon-dengji"/>}/>
                            <Step
                                status={quantity.SHIPPED_QUANTITY > 0 || quantity.LOCKED_QUANTITY > 0 || quantity.SCHEDULED_QUANTITY > 0 || quantity.PLAN_QUANTITY > 0 ? 'finish' : 'wait'}
                                title="接单处理"
                                description={`数量 ${quantity.PLAN_QUANTITY}`}
                                icon={<span className="tengen icon-storage"/>}/>
                            <Step
                                status={quantity.SHIPPED_QUANTITY > 0 || quantity.LOCKED_QUANTITY > 0 || quantity.SCHEDULED_QUANTITY > 0 ? 'finish' : 'wait'}
                                title="车间生产"
                                description={`数量 ${quantity.SCHEDULED_QUANTITY}`}
                                icon={<span className="tengen icon-product"/>}/>
                            <Step
                                status={quantity.SHIPPED_QUANTITY > 0 || quantity.LOCKED_QUANTITY > 0 ? 'finish' : 'wait'}
                                title="锁库待发"
                                description={`数量 ${quantity.LOCKED_QUANTITY}`}
                                icon={<span className="tengen icon-ruku"/>}/>
                            <Step
                                status={quantity.SHIPPED_QUANTITY > 0 ? 'finish' : 'wait'}
                                title="发运出库"
                                description={`数量 ${quantity.SHIPPED_QUANTITY}`}
                                icon={<span className="tengen icon-fahuo"/>}/>
                        </Steps>
                        <div className="dms-split-bar"></div>
                        <div className="time-line">
                            {(info.track || []).map((x, index) => (
                                <div key={index}>
                                    <div className="item">
                                        <p>
                                            <span>
                                                <span className="date">{x.date}/{x.day}</span>
                                                <span className="time">{x.time}</span>
                                                <span className={`dot${index === 0 ? ' last' : ''}`}>◉</span>
                                            </span>
                                            <b>{x.type}</b>
                                        </p>
                                        <p>{x.msg}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
                <Row style={{display: gpsTracks.length > 0 ? 'block' : 'none'}}>
                    <p className="track-bref">货物运输轨迹</p>
                </Row>
                <Row style={{display: gpsTracks.length > 0 ? 'block' : 'none'}}>
                    <div id="order-track-map-container" style={{width: '100%', height: '300px'}}/>
                </Row>
            </div>
        );
    };

    render() {
        const {
            rows, total, loading, searchObj, buyCompanyOptions, expandedRowKeys, opts, trackLoadingId, formKey,
        } = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'orderTime',
                    label: '订单日期',
                    options: [{text: '开始时间'}, {text: '结束时间'}],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.startCreatedDate || '',
                        end: searchObj.endCreatedDate || '',
                    },
                },
                {
                    name: 'getProCode',
                    label: '要货单号',
                    text: '输入要货单号',
                    type: 'default',
                    defaultValue: searchObj.getProCode,
                },
                {
                    name: 'orderCode',
                    label: '订单编号',
                    text: '输入订单编号',
                    type: 'default',
                    defaultValue: searchObj.orderCode,
                },
                {
                    name: 'buyCompanyId',
                    label: '购货单位',
                    text: '选择购货单位',
                    type: 'select',
                    options: buyCompanyOptions,
                    multiple: false,
                    showSearch: true,
                    defaultValue: searchObj.buyCompanyId,
                },
                {
                    name: 'productCode',
                    label: '物料编码',
                    text: '输入物料编码',
                    type: 'default',
                    defaultValue: searchObj.productCode,
                },
                {
                    name: 'productName',
                    label: '物料描述',
                    text: '输入物料描述',
                    type: 'default',
                    defaultValue: searchObj.productName,
                },
                {
                    name: 'qhFlag',
                    label: '是否欠货',
                    text: '选择是否欠货',
                    type: 'select',
                    options: [
                        {text: '全部', value: ''},
                        {text: '欠货', value: '1'},
                        {text: '不欠货', value: '0'},
                    ],
                    multiple: false,
                    defaultValue: searchObj.qhFlag,
                },
                {
                    name: 'status',
                    label: '状态',
                    text: '选择状态',
                    type: 'select',
                    options: TRACK_STATUS_LIST.map(item => ({text: item.label, value: item.value})),
                    multiple: false,
                    defaultValue: searchObj.status,
                },
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam,
        };
        const tableViewProps = {
            loading,
            rowKey: 'lineId',
            pageParam: {
                total,
                current: searchObj.p,
                pageSize: searchObj.s,
                onChange: this.pageChange,
            },
            expandedRowKeys,
            onExpand: (expanded, record) => this.openInfo(record),
            expandedRowRender: this.renderExpandedRow,
            columns: [
                {title: '要货单号', dataIndex: 'getProCode', width: 105},
                {title: '订单编号', dataIndex: 'orderCode', width: 100},
                {
                    title: '订单日期',
                    dataIndex: 'orderCreatedDate',
                    width: 100,
                    render: text => this.formatDate(text),
                },
                {title: '提货地点', dataIndex: 'pickProAddress', width: 130},
                {title: '购货单位', dataIndex: 'buyCompany', width: 140},
                {title: '物料编码', dataIndex: 'productCode', width: 120},
                {title: '物料描述', dataIndex: 'productName'},
                {title: '库存属性', dataIndex: 'stockType', width: 80},
                {title: '未发数量', dataIndex: 'count', width: 80},
                {title: '锁库数量', dataIndex: 'lockedQuantity', width: 80},
                {title: '欠货数量', dataIndex: 'qhQty', width: 80},
                {
                    title: '参考到货期',
                    dataIndex: 'referenceArrivalDate',
                    width: 100,
                    render: text => this.formatDate(text),
                },
                {title: '状态', dataIndex: 'status', width: 90, render: text => (
                    text ? <Tag color={TRACK_STATUS_COLOR[text] || 'default'}>{text}</Tag> : '-'
                )},
                {
                    title: '订单跟踪',
                    dataIndex: 'action',
                    width: 90,
                    render: (text, record) => (
                        trackLoadingId === record.lineId
                            ? <Spin size="small"/>
                            : <a onClick={() => this.openInfo(record)}>详情</a>
                    ),
                },
            ],
            rows,
            scroll: {x: 1400},
        };
        return (
            <div className="dms-body order-track-query-page">
                <DmsTab options={opts} defaultKey={0}/>
                <div className="advanceForm-box">
                    <div className="advanceForm-content">
                        <AdvanceFormNew key={formKey} {...advanceProps}/>
                    </div>
                </div>
                <div className="dms-table-box">
                    <div className="order-track-status-summary">
                        {TRACK_STATUS_LIST.map(item => (
                            <span
                                key={item.value}
                                className={`order-track-status-item${searchObj.status === item.value ? ' active' : ''}`}
                                onClick={() => this.filterByStatus(item.value === TRACK_STATUS_ALL ? '' : item.value)}
                            >
                                {item.label}
                                <em>{this.getStatusCount(item.value)}</em>
                            </span>
                        ))}
                    </div>
                    <div className="dms-table-content">
                        <TableView {...tableViewProps}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(OrderTrackQuery);



// WEBPACK FOOTER //
// ./src/routes/order/orderTrackQuery.js